import Repository from "./Repository";


export default {
  PostMedicalDirectorySearch(
    page,
    page_size = 10,
    circle_id,
    sort = "default",
    payload,
    payloadloc
  ) {
    // console.log(payloadloc,'payload loc');
    let loc =  payloadloc ? (payloadloc.lat && payloadloc.lng ?  `&lat=${payloadloc.lat}&lng=${payloadloc.lng}` : ''  ) : '' ;
    // console.log(loc ,'after api');
    return Repository.post(
      `/directoriessearch/?page=${page}&page_size=${page_size}&circle_id=${circle_id}&ordering=${sort}` +loc,
      payload
    );
  },
  
  PostMedicalDirectorySearchwithRec(
    page,
    page_size = 10,
    circle_id,
    sort = "default",
    payload,
    role
  ) {
    role ? payload.filters.item_type = role : ''
    console.log(payload);
    return Repository.post(
      `/directoriessearch/?page=${page}&page_size=${page_size}&circle_id=${circle_id}&ordering=${sort}`,
      payload
    );
  },
  geolocationSearch(payload) {
    return Repository.post(`geolocation/`,payload);
  }


};



// WEBPACK FOOTER //
// ./src/repositories/medicalDirectoryRepository.js